import { FormatConfig, StackFormatConfig } from '@y42/model';
import { ConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { Y42SeriesModel } from './common';
import { ColorByArea } from './sub-models/color.model';
import { AxisTypeEnum, DatosAxisModel, DatosAxisPointer, TextAlignEnum } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';
import { SortModel } from './sub-models/sort.model';
import { TooltipModel } from './sub-models/tooltip.model';

export class SimpleEchartsSettingsModel extends BaseEchartsSettingsModel<SimpleSeriesModel> {
  constructor(
    public series_on_y = true, // whether the series is on the y or x axis for horizontal and vertical chart

    public serieAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public rightSerieAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.left),
    // each chart has only one dimension this is why the axis is on the highest level
    public dimensionAxis: DatosAxisModel = new DatosAxisModel(
      null,
      AxisTypeEnum.category,
      series_on_y ? TextAlignEnum.center : TextAlignEnum.right,
    ),
    public show_stack_by = false, // whether the series should be stack on top of each other based on the breakdown,
    public show_stack_by_100_percent = false, // whether the stacked breakdowns show add up to 100%
    public stackFormatConfig: StackFormatConfig = new StackFormatConfig(),
    public colorBy?: {
      area: ColorByArea;
      hiddenValues: Record<string, boolean>;
    },
    public conditionalFormattingRules?: ConditionalFormattingRule[],
    public sort: SortModel = new SortModel(),
    series: SimpleSeriesModel[] = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    dimensions?: fieldId[],
    breakdowns?: fieldId[],
    public connectNulls?: boolean,
    public show_total_for_stacks: Array<number | 'all'> = [],
  ) {
    super(series, show_legend, axisPointer, dimensions, breakdowns);
  }
}

// grid horizontal / grid vertical
export class SimpleSeriesModel implements Y42SeriesModel {
  constructor(
    public field_id: fieldId | null = null,
    public mark: MarkTypeEnum = MarkTypeEnum.Bar,
    public stack_name = 1, // need as unique id
    public label: LabelModel = new LabelModel(),
    public tooltip: TooltipModel = new TooltipModel(),
    public show_right_axis = false,
    public format = 'inherit',
    public cumulative = false, // weather to stack the them on top or not
    public hidden = false,
    public formatConfig?: FormatConfig,
    public connectNulls?: boolean,
    public hideFalsyValues = true,
  ) {}
}
